// extracted by mini-css-extract-plugin
module.exports = {"footer":"AgeeementSignModal_footer__kxK3o","signPadHeader":"AgeeementSignModal_signPadHeader__3zSxq"};